"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrandTheme = exports.themeDefault = void 0;
var _defaultTheme = _interopRequireDefault(require("@kiwicom/orbit-components/lib/defaultTheme"));
var _fromPlainObject = _interopRequireDefault(require("@kiwicom/orbit-components/lib/fromPlainObject"));
const themeDefault = _defaultTheme.default;
exports.themeDefault = themeDefault;
const getBrandTheme = (brand, rtl = false) => ({
  orbit: (0, _fromPlainObject.default)(brand.theme.palette),
  rtl
});
exports.getBrandTheme = getBrandTheme;